import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../api";
import type { CursorPage, Datified, Schemas } from "../../api/types";
import { POLL_BASE_MS } from "./intervals";

export type AuditLog = Datified<Schemas["AuditLog"], "created_at">;

export interface AuditLogFilters {
  action?: string;
  entity_type?: string;
  q?: string;
  cursor?: string;
  limit?: number;
}

export function useAuditLogList(filters: AuditLogFilters = {}) {
  const u = new URLSearchParams();
  if (filters.action) u.set("action", filters.action);
  if (filters.entity_type) u.set("entity_type", filters.entity_type);
  if (filters.q) u.set("q", filters.q);
  if (filters.cursor) u.set("cursor", filters.cursor);
  if (filters.limit) u.set("limit", String(filters.limit));
  const s = u.toString();
  return useQuery<CursorPage<AuditLog>>({
    queryKey: ["audit-logs", filters],
    queryFn: () => apiGet<CursorPage<AuditLog>>("/audit-logs" + (s ? "?" + s : "")),
    refetchInterval: POLL_BASE_MS,
  });
}
